import React, { useContext } from 'react';
import Button from '@/components/Button/Button';
import ShareResourceDropdown from '@/components/ShareResourceDropdown/ShareResourceDropdown';
import SaveButton from '@/components/SaveButton/SaveButton';
import PrintButton from '@/components/PrintButton/PrintButton';
import ReferButton from '@/components/Referrals/ReferButton/ReferButton';
import AddToCollectionButton from '@/components/AddToCollectionButton/AddToCollectionButton';
import AddToBookmarkButton from '@/components/AddToBookmarkButton/AddToBookmarkButton';
import { AccountContext } from '@/context/account.context';
import { viewportContext } from '@/context/viewport.context';
import { modalContext } from '@/context/modal.context';
import Auth from '@/utils/api/odas/auth';
import t from '@/utils/Language/ShareResourceDropdown-translations';
import { ACTION_BUTTONS } from './constants';

const ActionButtons = ({ buttons = Object.values(ACTION_BUTTONS), resource, buttonVisibility, additionalClasses, secondOrigin }) => {
  const account = useContext(AccountContext);
  const { isXs } = useContext(viewportContext);
  const { enqueueModal } = useContext(modalContext);
  const buttonShape = isXs ? 'circle' : 'pill';

  // TODO: consider moving both of these to a helper function as they will likely be used
  // in other components in the future
  const actionButtons = [
    {
      name: ACTION_BUTTONS.PRINT,
      isVisible: buttonVisibility?.print || 'true',
      button: () => <PrintButton buttonType="default" buttonBorder={true} buttonShape={buttonShape} resource={resource} hideOnMobile={true} />
    },
    {
      name: ACTION_BUTTONS.SHARE,
      isVisible: buttonVisibility?.share || 'true',
      button: () => (
        <ShareResourceDropdown
          buttonStyles={{
            buttonType: 'default',
            buttonShape: buttonShape,
            buttonText: t('Share'),
            buttonBorder: false,
            buttonIcon: { style: 'fas', font: 'share-nodes' }
          }}
          resource={resource}
        />
      )
    },
    {
      name: ACTION_BUTTONS.ACTION,
      isVisible: buttonVisibility?.action || 'true',
      button: () =>
        isProUser() ? (
          <ReferButton buttonType="default" buttonShape={buttonShape} buttonBorder={true} resource={resource} additionalClasses={additionalClasses} />
        ) : (
          <SaveButton
            buttonType="default"
            buttonBorder={false}
            buttonShape={buttonShape}
            resource={resource}
            additionalClasses={additionalClasses}
            secondOrigin={secondOrigin}
          />
        )
    },

    {
      name: ACTION_BUTTONS.SIGN_UP,
      isVisible: buttonVisibility?.signUp || 'true',
      button: () => (
        <Button
          type="default"
          border={false}
          shape={buttonShape}
          icon={{ style: 'fas', font: 'user-plus' }}
          text={isXs ? '' : t('Sign up')}
          onButtonClick={() => enqueueModal({ name: 'SignupModal' })}
          additionalClasses={additionalClasses}
        />
      )
    },
    {
      name: ACTION_BUTTONS.ADD_TO_COLLECTION,
      isVisible: buttonVisibility?.addToCollection || 'true',
      button: () => (
        <AddToCollectionButton
          buttonType="default"
          buttonShape={buttonShape}
          buttonBorder={true}
          resource={resource}
          additionalClasses={additionalClasses}
        />
      )
    },
    {
      name: ACTION_BUTTONS.BOOKMARK,
      isVisible: buttonVisibility?.bookmark || 'true',
      button: () => (
        <AddToBookmarkButton
          buttonType="default"
          buttonShape={buttonShape}
          buttonBorder={true}
          resource={resource}
          additionalClasses={additionalClasses}
        />
      )
    }
  ];

  const isProUser = () => {
    return account?.state?.isLoggedIn && Auth.isAffiliatedPro();
  };

  return (
    <div className="d-flex flex-nowrap gap-2 gap-sm-1">
      {actionButtons
        .filter((button) => buttons.includes(button.name))
        .map((button, index) => {
          return <React.Fragment key={index}>{button.isVisible === 'true' && button.button()} </React.Fragment>;
        })}
    </div>
  );
};

export default ActionButtons;
